import { OrdersFilter } from "../../../models/Filter";

export const defaultFilter: OrdersFilter = {
  customerId: "",
  deliveryDate: "",
  destinationCity: "",
  destinationState: "",
  originCity: "",
  originState: "",
  pickupDate: "",
  search: "",
  page: 1,
  pageSize: 20,
  itemStates: "active",
  vinAge: "",
  vinPriority: [],
  vinEquality: "",
  vehicleModel: "",
};
